module.exports = __webpack_public_path__ + "assets/img/main-top-achievements-samsung-mobile.1c08d256.svg";